<template>
  <form class="space-y-6" @submit="onNativeFormSubmit">
    <FormInputText
      id="merchant"
      name="tenantIdentifier"
      label="Merchant Identifier"
      autocomplete="off"
      required
    />

    <FormInputText
      id="email"
      name="email"
      type="email"
      autocomplete="email"
      required
      label="Email Address"
    />

    <div class="flex justify-end">
      <FormSubmitButton :is-submitting="isSubmitting">
        Email access link
      </FormSubmitButton>
    </div>
  </form>
</template>

<script setup lang="ts">
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import z from "zod"
import { requestMagicLink } from "@/services/auth/requestMagicLink"

const formSchema = z.object({
  tenantIdentifier: z.string().min(1),
  email: z.string().email(),
})

const { handleSubmit, isSubmitting } = useForm({
  validationSchema: toTypedSchema(formSchema),
  initialValues: {
    tenantIdentifier: "",
    email: "",
  },
})

const onNativeFormSubmit = handleSubmit(async (values) => {
  try {
    await requestMagicLink(values)
    toast.success(
      "If an active account was found, a link to log in to your account has been emailed to the given email address."
    )
  } catch (error) {
    toast.error("Failed to request login link")
    logError(error)
  }
})
</script>
